import React from 'react';

import maths from './../documents/picturs/maths.png';
import fonction from './../documents/picturs/fonction.png';
import hardwork from './../documents/picturs/hardwork.png';
import test from './../documents/picturs/test.png';
import openbook from './../documents/picturs/openbook.png';
import think from './../documents/picturs/think.png';
import coding from './../documents/picturs/coding.png';


import AdsCard from './ads/AdsCard.js';
import Image from 'react-bootstrap/Image';
import ListGroup from 'react-bootstrap/ListGroup';
import Exercices from './exercices/Exercices.js';
import Cours from './cours/Cours.js';
// import { IconName } from "react-icons/ai";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

class SideNave extends React.Component{
  render(){
    return(

      <ListGroup className="mt-3 shadow-lg">
          <Link exact to="/"><ListGroup.Item action >
          <Image src={fonction} /><h4 className="inl">Mathsriyadiyat</h4>
          </ListGroup.Item></Link>
          <Link to="/cours"><ListGroup.Item action>
              <div>
              <Image src={openbook} /><h5 className="inl">Cours</h5>
              </div>
              </ListGroup.Item>

          </Link>

          <Link to="/exercices"><ListGroup.Item action >
          <Image src={maths} /><h5 className="inl">Exercices</h5>
          </ListGroup.Item></Link>

          <Link to="/devoir"><ListGroup.Item action >
          <Image src={test} /><h5 className="inl">Devoir</h5>
          </ListGroup.Item></Link>

          <Link to="/exam"><ListGroup.Item action >
          <Image src={hardwork} /><h5 className="inl">Examen</h5>
          </ListGroup.Item></Link>

          <Link to="/olympiad"><ListGroup.Item action >
          <Image src={think} /><h5 className="inl">Olympiad</h5>
          </ListGroup.Item></Link>
          <ListGroup.Item disabled>autres sujet</ListGroup.Item>

          <Link to="/programmation"><ListGroup.Item action >
          <Image src={coding} /><h5 className="inl">Programmation</h5>
          </ListGroup.Item></Link>
    
      </ListGroup>

    );
  }
}

export default SideNave;
